import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Column, Columns } from '@resurs/midas-react'
import pageableTable from '../../../higher-order/pageable-table'
import searchableTable from '../../../higher-order/searchable-table'

import AdminNewsArticle from './AdminNewsArticle'
import NewsDeleteDialog from '../Delete/NewsDeleteDialog'
import { useIntersection, useToggle } from '../../../util/utility-hooks'

const AdminNewsList = ({
  isLoading,
  articles,
  onLoadNextPage,
  onEdit,
  onDelete,
}) => {
  const [showDeleteConfirmation, toggleDeleteConfirmation] = useToggle(false)
  const [articleId, setArticleId] = useState('')
  const [loadingRef, loadMore] = useIntersection()

  const onSelectArticleToDelete = id => {
    setArticleId(id)
    toggleDeleteConfirmation()
  }

  const onConfirmDelete = () => {
    onDelete(articleId)
    toggleDeleteConfirmation()
  }

  useEffect(() => {
    if (loadMore) {
      onLoadNextPage()
    }
  }, [loadMore])

  return (
    <section>
      <Columns>
        <Column col2 colMd2 colSm12 />
        <Column col8 colMd8 colSm12>
          {articles.map(({ id, ...article }) => (
            <AdminNewsArticle
              key={id}
              article={article}
              onEdit={() => onEdit(id)}
              onDelete={() => onSelectArticleToDelete(id)}
            />
          ))}
          <div ref={loadingRef}>
            {isLoading && (
              <div style={{ padding: '2rem 0', textAlign: 'center' }}>
                <span className={midas.loading} />
              </div>
            )}
          </div>
        </Column>
        <Column col2 colMd2 colSm12 />
      </Columns>
      {showDeleteConfirmation && (
        <NewsDeleteDialog
          onConfirm={onConfirmDelete}
          onClose={toggleDeleteConfirmation}
        />
      )}
    </section>
  )
}

AdminNewsList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  articles: PropTypes.array.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onLoadNextPage: PropTypes.func.isRequired,
}

AdminNewsList.defaultProps = {
  onEdit: null,
  onDelete: null,
}

export default searchableTable(pageableTable(AdminNewsList))
